var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDoubleLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0303 16.5303C10.7374 16.8232 10.2626 16.8232 9.96967 16.5303L5.96967 12.5303C5.67678 12.2374 5.67678 11.7626 5.96967 11.4697L9.96967 7.46967C10.2626 7.17678 10.7374 7.17678 11.0303 7.46967C11.3232 7.76256 11.3232 8.23744 11.0303 8.53033L7.56066 12L11.0303 15.4697C11.3232 15.7626 11.3232 16.2374 11.0303 16.5303Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0303 17.5303C17.7374 17.8232 17.2626 17.8232 16.9697 17.5303L11.9697 12.5303C11.6768 12.2374 11.6768 11.7626 11.9697 11.4697L16.9697 6.46967C17.2626 6.17678 17.7374 6.17678 18.0303 6.46967C18.3232 6.76256 18.3232 7.23744 18.0303 7.53033L13.5607 12L18.0303 16.4697C18.3232 16.7626 18.3232 17.2374 18.0303 17.5303Z",
    fill: "current"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleLeft);
export default __webpack_public_path__ + "static/media/double-left.f9bfb1afaedadad66488fdc5ba9d7367.svg";
export { ForwardRef as ReactComponent };